<template>
  <f7-page
    @page:init="onPageInit"
    infinite
    :infinite-distance="50"
    :infinite-preloader="showPreloader"
    @infinite="loadMore"
  >
    <f7-navbar :back-link="$t('back')">
      <f7-nav-title>{{ $t("Product.Title") }}</f7-nav-title>
      <langButton></langButton>
    </f7-navbar>
    <f7-list
      media-list
      virtual-list
      :virtual-list-params="{
        height: theme.ios ? 63 : theme.md ? 73 : 77,
      }"
    >
      <f7-list-item
        :footer="item.Remark"
        :title="$field(item.Name)"
        v-for="(item, index) in list"
        :key="index"
        :subtitle="$field(item.ProductType.Name)"
        :link="`/Product/Edit/${item.Eid}/`"
      >
        <template #media v-if="item.Cover != null && item.Cover != ''">
          <div
            class="coverimg"
            :style="{
              backgroundImage: 'url(' + baseCoverUrl + item.Cover + ')',
            }"
          ></div></template
        ><template #text>
          <div class="zt">
            <f7-badge :color="item.Enabled ? 'green' : 'red'">{{
              item.Enabled ? $t("enabled") : $t("disable")
            }}</f7-badge>
          </div></template
        ><template #after>
          <span class="text_red">s${{ item.Price }}</span>
        </template></f7-list-item
      >
    </f7-list>
  </f7-page>
</template>
<script>
import util from "util/date";
import { base, getProductList } from "@/api/api";
import { theme, f7 } from "framework7-vue";

export default {
  props: {
    f7route: Object,
  },
  data() {
    return {
      theme,
      allowInfinite: true,
      showPreloader: false,
      list: [],
      total: 0,
      page: 1,
      baseCoverUrl: base + "/FileUpload/Product/a0/",
    };
  },
  methods: {
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy-MM-dd hh:mm");
    },
    loadMore() {
      const self = this;
      if (!self.allowInfinite) return;
      self.allowInfinite = false;

      self.showPreloader = true;
      self.getList();
    },
    //获取列表
    getList(isload = false) {
      const self = this;
      if (isload) {
        f7.preloader.show();
        self.page = 1;
        self.list = [];
      }
      let para = {
        page: this.page,
        shopId: window.localStorage.Shop_Id,
      };
      getProductList(para).then((res) => {
        self.list = self.list.concat(res.data.response.data);
        f7.preloader.hide();
        self.showPreloader = false;
        if (res.data.response.data.length > 0) {
          self.page++;
          self.allowInfinite = true;
        }
      });
    },
    onPageInit() {
      this.getList(true);
    },
  },
};
</script>
<style scoped>
.zt {
  text-align: right;
}
.zt .badge {
  border-radius: 5px;
}
</style>